import React from "react";
import "./index.css";
import { Button } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

type QuantitySelectorParams = {
  quantity: number;
  increaseDisabled: boolean;
  onIncrease: () => void;
  onDecrease: () => void;
};

export const QuantitySelector: React.FC<QuantitySelectorParams> = ({
  quantity,
  increaseDisabled,
  onDecrease,
  onIncrease,
}) => {
  return (
    <div className="quantity-selector">
      <Button
        type="link"
        icon={<PlusOutlined />}
        className="quantity-selector-button"
        disabled={increaseDisabled}
        onClick={onIncrease}
      />
      <div className="quantity-selector-value">{quantity}</div>
      <Button
        type="link"
        icon={<MinusOutlined />}
        className="quantity-selector-button"
        disabled={quantity === 1}
        onClick={onDecrease}
      />
    </div>
  );
};
